module.exports = __webpack_public_path__ + "static/img/fkzt1.1334c9b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/newestqianniu/fkzt1.png
// module id = 318
// module chunks = 0